<div
  class="action-buttons-group"
  sui-radio-group
  [ngModel]="globalAction"
  [ngModelOptions]="{ standalone: true }"
  (ngModelChange)="onGlobalActionChange($event)"
>
  <sui-radio value="copy">
    {{ "widget-actions.to-other-dashbords.label-copy" | translate }}
  </sui-radio>
  <sui-radio value="move">
    {{ "widget-actions.to-other-dashbords.label-move" | translate }}
  </sui-radio>
</div>

<div class="table-container">
  <table class="table table-bordered table-hover">
    <thead class="table-header-sticky">
      <tr>
        <th scope="col" class="col-widget-title">
          {{ "widget-actions.to-other-dashbords.col-widget-title" | translate }}
        </th>
        <th scope="col" class="col-action">
          {{ "widget-actions.to-other-dashbords.col-action" | translate }}
        </th>
        <th scope="col" class="col-destination">
          {{ "widget-actions.to-other-dashbords.col-destination" | translate }}
        </th>
        <th scope="col" class="col-page-strategy">
          <div class="page-strategy-header">
            <span class="label">{{
              "widget-actions.to-other-dashbords.page-strategy-header"
                | translate
            }}</span>
            <sui-select [(ngModel)]="pageStrategy">
              @for (option of pageStrategyOptions; track option) {
                <sui-select-option
                  [value]="option.value"
                  [label]="option.label"
                >
                  {{ option.label }}
                </sui-select-option>
              }
            </sui-select>
          </div>
        </th>
      </tr>
    </thead>

    <tbody>
      @for (widget of widgets; track widget; let i = $index) {
        <tr>
          <!-- Widget Title Column -->
          <td class="widget-title-cell">
            <div class="widget-title-content">
              <fa-icon
                [icon]="['fas', 'chart-bar']"
                class="widget-icon me-2"
              ></fa-icon>
              <span class="widget-title">{{ widget.title }}</span>
            </div>
          </td>
          <!-- Action Column -->
          <td class="action-cell">
            <div class="action-display">
              <span class="action-badge">
                {{ getActionDisplayText(globalAction) }}
              </span>
            </div>
          </td>
          <!-- Destination Dashboards Column (Rowspan) -->
          @if (i === 0) {
            <td
              [attr.rowspan]="widgets.length"
              class="destination-cell-rowspan"
            >
              <div class="destination-content">
                <sui-button
                  variant="primary"
                  [leadingIcon]="['fas', 'plus']"
                  class="mb-2"
                  (click)="openDashboardPicker()"
                  >Select Dashboards</sui-button
                >
                @if (selectedDashboards.length > 0) {
                  <div class="selected-objects-list">
                    @for (dashboard of selectedDashboards; track dashboard) {
                      <div class="selected-object-item">
                        <fa-icon
                          [icon]="['fas', 'chart-pie']"
                          class="object-icon"
                        ></fa-icon>
                        <span class="object-name">{{ dashboard.title }}</span>
                        <sui-button
                          variant="danger"
                          [leadingIcon]="['fas', 'times']"
                          [iconOnly]="true"
                          ariaLabel="Remove"
                          (click)="removeDashboard(dashboard.id)"
                        ></sui-button>
                      </div>
                    }
                  </div>
                }
                @if (selectedDashboards.length === 0) {
                  <div class="no-selection-message">
                    <fa-icon
                      [icon]="['fas', 'info-circle']"
                      class="me-2"
                    ></fa-icon>
                    <span>{{
                      "widget-actions.to-other-dashbords.no-selection-message"
                        | translate
                    }}</span>
                  </div>
                }
              </div>
            </td>
          }
          <!-- Page Strategy Column (Rowspan) -->
          <td class="page-strategy">
            <div class="page-strategy-display">
              <span class="strategy-badge">{{ pageStrategy | uppercase }}</span>
            </div>
          </td>
        </tr>
      }
    </tbody>
  </table>
</div>
